import { AppThunkAction } from '../index';

export function setPerformanceOpen(open: $TSFixMe): AppThunkAction {
  return (dispatch) => {
    dispatch({ type: 'SET_PERFORMANCE_OPEN', payload: open });
  };
}
